import React from "react";
import GetStarted from "@components/shared/GetStarted/GetStartedForm";
import ConnectorFormOAuth from "../ConnectorFormOAuth/ConnectorFormOAuth";

const ZoomSetup = () => {
  return <GetStarted connectorForm={ConnectorFormOAuth} showCustomForm />;
};

export default ZoomSetup;
